// extracted by mini-css-extract-plugin
module.exports = {"wrap":"priceSetPage_wrap__tu4YQ","queryWrap":"priceSetPage_queryWrap__1wj7P","tableWrap":"priceSetPage_tableWrap__297bi","btnWrap":"priceSetPage_btnWrap__1kg8i"};